import GeneralRepository from "core/data/GeneralRepository";
import { ICittadinanza } from "core/interfaces/data/IGeneralRequest";

import i18n from "./i18n";

const monthCF: { [id: string]: number } = {
	A: 0,
	B: 1,
	C: 2,
	D: 3,
	E: 4,
	H: 5,
	L: 6,
	M: 7,
	P: 8,
	R: 9,
	S: 10,
	T: 11,
};

const getDatiUtenteFromCF = async (codiceFiscale: string) => {
	let isCfCompleto = codiceFiscale.length === 16;

	if (isCfCompleto) {
		let cfGiorno = codiceFiscale.substring(9, 11);
		let cfMese = codiceFiscale.substring(8, 9);
		let cfAnno = codiceFiscale.substring(6, 8);
		let municipalityCode = codiceFiscale.substring(11, 15);

		let giornoNascita: number;

		if (isNaN(Number(cfGiorno)) || isNaN(Number(cfAnno)) || monthCF[cfMese] === undefined) {
			return undefined;
		}

		let sesso = !isNaN(Number(cfGiorno)) ? (Number(cfGiorno) > 40 ? "F" : "M") : undefined;

		giornoNascita = Number(cfGiorno);

		if (sesso === "F") {
			giornoNascita = Number(cfGiorno) - 40;
		}
		let anno = Number(cfAnno);

		if (new Date().getFullYear() - (1900 + anno) > 100) {
			anno = 2000 + anno;
		} else {
			anno = 1900 + anno;
		}

		let dataNascita = new Date(anno, monthCF[cfMese], giornoNascita);

		let comune = await GeneralRepository.getComuniByCf({
			CfComune: municipalityCode,
			OnlyValid: true,
			culture: i18n.language,
		});
		if (!comune) {
			comune = await GeneralRepository.getComuniByCf({
				CfComune: municipalityCode,
				OnlyValid: false,
				culture: i18n.language,
			});
		}

		var cittadinanza: ICittadinanza|undefined;
		if (comune && comune.Provincia!=='EE')
		 cittadinanza=(await GeneralRepository.getCittadinanze({
			Descrizione: "100",
			culture: i18n.language,
		}))![0]
		

		return { sesso, dataNascita, comune,cittadinanza };
	} else {
		return undefined;
	}
};
//Controlla se è già presente in Atlante un assistito con lo stesso codice fiscale
const checkAssistedExists = async (fiscalCode: string) => {
	return await GeneralRepository.checkAssistedExists({
		Value: fiscalCode,
		culture: i18n.language,
	});
};

//Controlla se è già presente account con lo stesso codice fiscale
const checkLoginExists = async (fiscalCode: string) => {
	return await GeneralRepository.checkLoginExistsByCF({
		Value: fiscalCode,
		culture: i18n.language,
	});
};

//Controlla se è già presente account con lo stesso codice fiscale
const checkPersRifExists = async (fiscalCode: string) => {
	return await GeneralRepository.checkPersRifExistsByCF({
		Value: fiscalCode,
		culture: i18n.language,
	});
};

export { getDatiUtenteFromCF, checkAssistedExists, checkLoginExists, checkPersRifExists, monthCF };
